'use strict';

import Timeline from "../anims/timeline";

var timelineTimer;

const changeVideo = function (index) {
    // stop all vids
    let btnStop = document.querySelectorAll('.stopVideo');
    btnStop.forEach(btn => {
        btn.click();
    });
    // active switch option
    videoHome.switch = true;
    // set index on vids
    videoHome.index[0] = index;
    // play video
    document.querySelector('.mainSlide.tns-slide-active .btn_play').click();
};

const videoHome = {
    iframeCtn: [],
    iframeObjects: [],
    timeline2: new Timeline('#timeline2', changeVideo),
    popin: document.querySelector('.home .bVideo_popin'),
    popinClose: document.querySelector('.home .bVideo_popin-close'),
    player: '',
    videos: {
        0: []
    },
    index: {
        0: 0
    },

    init: function () {
        //videoHome.displayRGPD();
    },

    onYouTubeIframeAPIReady: function () {
        let iframes = document.querySelectorAll('.video-js');

        iframes.forEach(function (iframe, index) {
            let iframeCtn = [];
            let data = [
                iframe.dataset.id,
                iframe.dataset.playlist,
                iframe.dataset.start,
                iframe.dataset.startlist,
                iframe.id
            ];
            iframeCtn.push(data);

            iframeCtn.forEach((iframeData) => {
                let videoId = iframeData[0];
                let start = iframeData[2];
                let idIframe = iframeData[4];
                let videoParams = {
                    vid: videoId,
                    startSeconds: parseInt(start),
                    endSeconds: parseInt(start) + 5,
                    id: idIframe
                };
                // videoHome.videos.push(iframe);
                videoHome.videos[index].push(videoParams);

                let videoPlaylist = iframeData[1].split(',');
                let startList = iframeData[3].split(',');
                let i = 0;
                videoPlaylist.forEach(function () {
                    let videoParams2 = {
                        vid: videoPlaylist[i],
                        startSeconds: parseInt(startList[i]),
                        endSeconds: parseInt(startList[i]) + 5
                    };
                    videoHome.videos[index].push(videoParams2);
                    i++;
                });
            });

            let playerVars = {
                'rel': 0,
                'showinfo': 0,
                'controls': 0,
                'loop': 1,
                'autoplay': 0,
                'mute': 1,
                'playsinline': 1
            };
            // console.log(videoHome.videos[0][0].vid);
            let _this = videoHome;
            _this.player = new YT.Player(videoHome.videos[index][0].id, {
                'host': 'https://www.youtube.com',
                'videoId': videoHome.videos[index][0].vid,
                'height': '360',
                'width': '640',
                'playerVars': playerVars,
                'events': {
                    'onReady': videoHome.onPlayerReady,
                    'onStateChange': videoHome.onPlayerStateChange
                }
            });
        });
    },

    onPlayerReady: function (event, i) {
        let _this = videoHome;

        let iframeObject = event.target;
        let videoContainer = event.target.getIframe().parentElement.parentElement;
        let buttonPlay = videoContainer.querySelector('.btn_play');

        if (!window.matchMedia("(min-width: 1100px)").matches && document.querySelector('.mainSlide.tns-slide-active .btn_play')) {
            document.querySelector('.mainSlide.tns-slide-active .btn_play').style.display = "block";
            document.querySelector('.mainSlide.tns-slide-active .btn_play').style.opacity = "1";
        } else {
            videoContainer.classList.add('played');
        }

        let currentIframe = event.target.getIframe().dataset.index;
        let videos = videoHome.videos[currentIframe];
        event.target.cueVideoById({
            'videoId': videos[videoHome.index[currentIframe]].vid,
            'startSeconds': videos[videoHome.index[currentIframe]].startSeconds,
            'endSeconds': videos[videoHome.index[currentIframe]].endSeconds
        });

        // Push current iframe object to array
        _this.iframeObjects.push(iframeObject);

        buttonPlay.addEventListener('click', function () {
            clearInterval(timelineTimer);
            // Pause all videos currently playing
            _this.iframeObjects.forEach(function (scopediframeObject) {
                scopediframeObject.pauseVideo();
                let scopediframeElement = scopediframeObject.getIframe().closest('.bVideo');
                if (scopediframeElement)
                    scopediframeElement.classList.remove('played');
            });

            if (videoHome.switch === true) {
                let currentIframe = iframeObject.getIframe().dataset.index;
                let i = videoHome.index[currentIframe];
                event.target.cueVideoById({
                    'videoId': videoHome.videos[currentIframe][i].vid,
                    'startSeconds': videoHome.videos[currentIframe][i].startSeconds,
                    'endSeconds': videoHome.videos[currentIframe][i].endSeconds
                });
                videoHome.switch = false;
            } else {
                let currentIframe = iframeObject.getIframe().dataset.index;
                let videos = videoHome.videos[currentIframe];
                event.target.cueVideoById({
                    'videoId': videos[videoHome.index[currentIframe]].vid,
                    'startSeconds': videos[videoHome.index[currentIframe]].startSeconds,
                    'endSeconds': videos[videoHome.index[currentIframe]].endSeconds
                });
            }
            iframeObject.playVideo();
            setTimeout(function () {
                videoContainer.classList.add('played');
            }, 600);
        });

        buttonPlay.addEventListener('touchend', function () {
            clearInterval(timelineTimer);
            // Pause all videos currently playing
            _this.iframeObjects.forEach(function (scopediframeObject) {
                scopediframeObject.pauseVideo();
                let scopediframeElement = scopediframeObject.getIframe().closest('.bVideo');
                if (scopediframeElement)
                    scopediframeElement.classList.remove('played');
            });
            if (videoHome.switch === true) {
                let currentIframe = iframeObject.getIframe().dataset.index;
                let i = videoHome.index[currentIframe];
                event.target.cueVideoById({
                    'videoId': videoHome.videos[currentIframe][i].vid,
                    'startSeconds': videoHome.videos[currentIframe][i].startSeconds,
                    'endSeconds': videoHome.videos[currentIframe][i].endSeconds
                });
                videoHome.switch = false;
            } else {
                let currentIframe = iframeObject.getIframe().dataset.index;
                let videos = videoHome.videos[currentIframe];
                event.target.cueVideoById({
                    'videoId': videos[videoHome.index[currentIframe]].vid,
                    'startSeconds': videos[videoHome.index[currentIframe]].startSeconds,
                    'endSeconds': videos[videoHome.index[currentIframe]].endSeconds
                });
            }
            iframeObject.playVideo();
            setTimeout(function () {
                videoContainer.classList.add('played');
            }, 600);
        });


        let stopVideo = videoContainer.querySelector('.stopVideo');
        stopVideo.addEventListener('click', function () {
            clearInterval(timelineTimer);
            iframeObject.stopVideo();
            videoHome.index[0] = 0;

            let progressBar = document.querySelector('.mainSlide.tns-slide-active .mainSlide_media:not(.mainSlide_news) .progressBar');
            if (progressBar)
                progressBar.style.display = 'none';
        });

        if (videoContainer.parentElement.classList.contains('tns-slide-active') && window.matchMedia("(min-width: 1100px)").matches) {
            iframeObject.playVideo();
        }
    },

    onPlayerStateChange: function (event) {
        let player = event.target;
        let iframe = event.target.getIframe();
        let container = iframe.parentElement.parentElement;
        let currentIframe = iframe.dataset.index;
        let index = videoHome.index[currentIframe];
        let progressBar = document.querySelector('.mainSlide.tns-slide-active .mainSlide_media:not(.mainSlide_news) .progressBar');
        var state = event.data;
        
        switch (state) {
            case YT.PlayerState.ENDED:
                // console.log('ENDED : vidéo numéro ', index);

                clearInterval(timelineTimer);

                if (progressBar) {
                    progressBar.style.display = 'none';
                }

                if (videoHome.index[currentIframe] >= videoHome.videos[currentIframe].length) {
                    videoHome.index[currentIframe] = 0;
                }
                let i = videoHome.index[currentIframe];
                // console.log(index);
                player.loadVideoById({
                    'videoId': videoHome.videos[currentIframe][i].vid,
                    'startSeconds': videoHome.videos[currentIframe][i].startSeconds,
                    'endSeconds': videoHome.videos[currentIframe][i].endSeconds
                });
                break;

            case YT.PlayerState.PLAYING:
                // console.log('PLAYING : vidéo numéro ', index);
                // remove class displayRgpd if it is
                
                /*
                let rgpdClass = document.querySelector('.mainSlide.displayRgpd');
                if (rgpdClass)
                    rgpdClass.classList.remove('displayRgpd');
                */

                // slider titles
                let title = container.querySelector('.mainSlide_content.active');
                if (title)
                    title.classList.remove('active');
                let indexVid = index + 1;
                let active_title = container.querySelector('.mainSlide_content[data-id="' + indexVid + '"]');
                if (active_title)
                    active_title.classList.add('active');

                // custom progress bar
                if (progressBar)
                    progressBar.style.display = 'block';

                let videoPart = index * 25;
                let int = 0;
                timelineTimer = setInterval(function () {
                    int = int + .25;
                    let percentBar = int + videoPart;
                    if (videoPart + 25 >= percentBar) {
                        // console.log(percentBar);
                        container.classList.contains('slide_youtube') ? videoHome.timeline2.updateTimer(percentBar) : videoHome.timeline1.updateTimer(percentBar);
                    }
                }, 50);

                // increment index
                videoHome.index[currentIframe]++;
                break;

            case YT.PlayerState.BUFFERING:
                // console.log('BUFFERING : vidéo numéro ', videoHome.index[currentIframe]);
                break;

            case YT.PlayerState.PAUSED:
            case YT.PlayerState.CUED:
            default:
        }
    },
    /*
    displayRGPD: function () {
        if (document.querySelector('.mainSlide_5') && tarteaucitron.state.youtubeapi !== true) {
            document.querySelector('.mainSlide_5').classList.add('displayRgpd');
        }
    }
    */
};

export default videoHome;


// WEBPACK FOOTER //
// ./src/scripts/components/videoHome.js